import { render } from "./RascunhoCartaProposta.vue?vue&type=template&id=771f634c&scoped=true"
import script from "./RascunhoCartaProposta.vue?vue&type=script&lang=js"
export * from "./RascunhoCartaProposta.vue?vue&type=script&lang=js"

import "./RascunhoCartaProposta.vue?vue&type=style&index=0&id=771f634c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771f634c"]])

export default __exports__